'use client';

import { useChat } from '../context/ChatContext';
import ChatContainer from './ChatContainer';
import Sparkle from '@src/assets/svg/sparkle';
import { Switch } from '@src/v3/components/coreUI/switch';
import useAiSearch from '../hooks/useAiSearch';

export default function FloatingChatButton() {
  const { isOpen, openChat } = useChat();
  const { enabled: isAiEnabled, setEnabled: setIsAiEnabled } = useAiSearch();

  if (!isAiEnabled)
    return (
      <div className="fixed inset-x-0 bottom-6 z-50 flex justify-center">
        <div className="relative">
          <div
            className="
            font-geist
            relative
            z-10
            flex
            items-center
            gap-4
            rounded-[24px]
            bg-white
            px-[20px]
            py-[12px]
            text-base
            font-medium
            text-black
            shadow-sm
            transition

            active:scale-95
          "
            role="group"
          >
            <div className="flex items-center gap-4">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--Color-Themes-Gray-900,#666)] text-white">
                <Sparkle />
              </div>
              <span className="whitespace-nowrap">Enable Ai Mode</span>
            </div>

            <div className="ml-4">
              <Switch
                checked={isAiEnabled}
                onCheckedChange={(val: boolean) => {
                  setIsAiEnabled(Boolean(val));
                  openChat();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  return (
    <>
      {!isOpen && (
        <div className="fixed inset-x-0 bottom-6 z-50 flex justify-center">
          <div className="relative">
            <div
              className="
                pointer-events-none
                absolute
                -inset-1
                rounded-[24px]
                bg-[linear-gradient(135deg,rgba(0,108,255,0.2),rgba(247,31,248,0.2))]
                blur-lg
              "
            />

            <button
              onClick={openChat}
              className="
                font-geist
                relative
                z-10
                flex
                items-center
                gap-4
                rounded-[24px]
                bg-white
                px-[24px]
                py-[16px]
                text-base
                font-medium
                text-black
                shadow-sm
                transition
                hover:scale-[1.03]
                active:scale-95
              "
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#006CFF] text-white">
                <Sparkle />
              </div>

              <span className="whitespace-nowrap">Search for a new home</span>
            </button>
          </div>
        </div>
      )}

      {isOpen && <ChatContainer />}
    </>
  );
}
